import React from 'react';
import classNames from 'classnames';

import styles from './index.module.scss';

type Props = {
    className?: string;
    noPadding?: boolean;
}
const defaultProps = {
    className: '',
    noPadding: false,
};

export const Page: React.FC<Props> = ({ children, className, noPadding}) => {
    const pageClass = classNames({
        // container: true,
        [styles.page]: true,
        [styles.noPadding]: noPadding,
        [className]: !!className,
    });

    return <div className={pageClass}>{children}</div>;
}

Page.defaultProps = defaultProps;
